import { registerQuery } from 'data-fetching-client';
import { createRpcClientV2 } from 'rpc-client-utils';
import authHttpClient from 'hub-http/clients/apiClient';
import { submitFeedbackRpc } from 'automation-ui-canvas/__generated__/chirp/com/hubspot/automation/action/recommendation/rpc/AutomationActionRecommendationRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: authHttpClient
});
export const SEND_NEXT_ACTION_RECOMMENDATION_FEEDBACK = registerQuery({
  fieldName: 'sendNextActionRecommendationFeedback',
  args: ['chirpAiContextObject', 'positiveFeedback', 'explicitFeedback', 'feedbackText'],
  fetcher(request) {
    return chirpClient.call(submitFeedbackRpc, {
      request
    });
  }
});